export default {"src":"/_next/static/media/checkmark.f85b65f6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};